// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminTransactionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminTransactionsResponse — full platform-revenue ledger for staff.
 *
 * Used by GET /subscriptions/admin/transactions.
 * Rows are ordered newest-first (created_at DESC, id DESC).
 * Each row carries franchise_name + an embedded attempts trail.
 */
import type { Subscriptions_AdminTransactionRow } from './Subscriptions_AdminTransactionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminTransactionsResponseDados {
rows: Subscriptions_AdminTransactionRow[]
}

export type Subscriptions_AdminTransactionsResponse = ApiResponse<Subscriptions_AdminTransactionsResponseDados>;

registerResponseContract('Subscriptions_AdminTransactionsResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                 { type: 'number',  required: true },
      subscription_id:    { type: 'number',  required: true },
      franquia_id:        { type: 'number',  required: true },
      franchise_name:     { type: 'string',  required: false },
      kind:               { type: 'string',  required: false },
      amount_cents:       { type: 'number',  required: false },
      currency:           { type: 'string',  required: false },
      status:             { type: 'string',  required: false },
      provider:           { type: 'string',  required: false },
      provider_charge_id: { type: 'string',  required: false },
      paid_at:            { type: 'string',  required: false },
      created_at:         { type: 'string',  required: false },
      attempts: {
        type: 'array',
        required: false,
        items: {
          status:     { type: 'string',  required: false },
          event_type: { type: 'string',  required: false },
          created_at: { type: 'string',  required: false },
        },
      },
    },
  },
})
